import React, { Component, PropTypes } from 'react';
import t from 'tcomb-form';
import flattenDeep from 'lodash/array';
import union from 'lodash/array';
import isLoggedIn from '../utils/index';
import {uniq, pull, difference} from 'lodash/array';
import { BasicForm, InputField } from 'react-serial-forms';

export default class UserInterestsStep2 extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    categoryRoots: [],
    previouslySavedChildCategories: [],
    categoryObjs: this.props.categoryRootObjs,
    currentUrl: this.props.currentPageUrl
  };

  getFirstChildCategoresFromSelectedRoots = (selectedCategoryRootIds) => {
    let selectedCategoryObjs = [];

    // Pull the selected category objects from props
    let categoryRoots = this.props.baseState.categories.map(rootCategoryItem => {

      for (let i=0; i<selectedCategoryRootIds.length; i++) {
        if (selectedCategoryRootIds[i].rootid == rootCategoryItem.id) {
          selectedCategoryObjs.push(rootCategoryItem)
        }
      }
    });

    return selectedCategoryObjs;
  };

  collectCategoryIds(formData) {
    let dirtyIds = [];

    for(let key of Object.keys(formData)) {
      if(formData[key]) {
        dirtyIds.push(key);
      }
    }

    let categoryIds = dirtyIds.map(item => {
      return Number(item);
    });

    const ids = uniq(categoryIds)
    return ids
  }



  handleChildInterestChanged = (checkboxId, rootId) => {
    this.props.updateParentCategoryChildState(checkboxId, rootId);

    // Update local state so we force re-render
    this.setState({categoryObjs: this.props.categoryRootObjs});
  }

  handleSubmit = e => {
    e.preventDefault();
    let form = this.refs.profileInterestsForm;
    form.validate(errors=> {
      if (this.state.currentUrl == '/my/interests') {
        // Send user to UserInterestsStep1 on profile section
        if(!errors) {
          this.props.saveMyInterests(this.collectCategoryIds(form.serialize())).then(this.props.goToStep1());
        }
      } else {
        // Send user to profile section of site
        if(!errors) {
          this.props.doSaveUserInfoStep({});
          this.props.saveMyInterests(this.collectCategoryIds(form.serialize())).then(this.props.redirectUser());
        }
      }
    });
  };

  render() {
    const { categories } = this.props.baseState;

    let selectedCategoryRootIds = this.props.categoryRootObjs;

    let clickedCategoryChildrenIds = [];
    let selectedCategories = this.getFirstChildCategoresFromSelectedRoots(selectedCategoryRootIds);

    let categoryLists = '';
    categoryLists = selectedCategories.map((categoryRoot, index) => {

      // Pull the childIds from categoryRootObjs[index]
      let categoryRootsObjArray = this.props.categoryRootObjs.filter((obj) => {
        return obj.rootid == categoryRoot.id;
      });

      if (categoryRootsObjArray.length > 0) {
        // pull the childIds
        clickedCategoryChildrenIds = categoryRootsObjArray[0].childId;
      }



      let children = categoryRoot.children.map((categoryChild, index) => {

        let checked = { checked: false, value: 0 };

        if (clickedCategoryChildrenIds.indexOf(categoryChild.id) != -1){
          checked = { checked: true, value: 1 };
        } else {
          checked = { checked: false, value: 0 };
        }


        return <div className="profile-InterestCheckbox">

          <InputField type='checkbox' {...checked}
            name={categoryChild.id.toString()} id={'id-' + categoryChild.id}
            onChange={this.handleChildInterestChanged.bind(null, categoryChild.id, categoryRoot.id)} />

            <label htmlFor={'id-' + categoryChild.id}>{categoryChild.name}</label>
          </div>;
      });
      return <div className={`profile-interestsCategory`}>
        <div className={`profile-interestsCategoryTitle`}>{categoryRoot.name}</div>
        {children}
        </div>;
    });

    return (
      <div>
        <div>
          <BasicForm className="profile-InterestsForm" ref="profileInterestsForm" onSubmit={this.handleSubmit}>
            {categoryLists}
            <div className="interests-submit-wrapper">

              <button onClick={this.handleSubmit} className="my-interests-submit my-account-submit submitButton button-primary" type="submit">FINISH!</button>&nbsp;

            </div>
          </BasicForm>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/UserInterestsStep2.jsx